import { Button } from 'antd'
import { useState, VFC } from 'react'
import { useTranslation } from 'react-i18next'

import { ImportEmployeesUploadCvs } from '@/components/pages/Employees/Import'
import ImportPageHeader from '@/components/pages/ImportPageHeader'

import { useImportTank } from './Import.hooks'

const ImportTank: VFC = () => {
  const [fileName, setFileName] = useState('')
  const [t] = useTranslation()
  const { loading, importCsvTank } = useImportTank()
  const [file, setFile] = useState<File | null>(null)

  const handleFileSelected = (data: FormData) => {
    const file = data.get('file') as File
    setFileName(file.name)
    setFile(file)
  }

  const handleSubmit = () => {
    if (file) {
      const payload = {
        tankNoIdx: 0,
        detergentNameIdx: 1,
        methodIdx: 2,
        thresholdQuantityIdx: 4,
        remainingQuantityIdx: 5,
      }

      const formData = new FormData()
      formData.append('file', file)
      formData.append('payload', JSON.stringify(payload))

      importCsvTank(formData)
    }
  }

  return (
    <>
      <ImportPageHeader title={t('pages.tanks.importFromCsv.title')} />
      <ImportEmployeesUploadCvs loading={loading} onUpload={handleFileSelected} fileName={fileName} />
      <Button disabled={!fileName} type="primary" onClick={handleSubmit} style={{ marginTop: '20px' }}>
        {t('pages.employees.importFromCsv.submit')}
      </Button>
    </>
  )
}

ImportTank.displayName = 'ImportTank'
export default ImportTank
